document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.js-go-back-cta' ).forEach( ( $el ) => {
		if ( history.length > 1 ) {
			const previousUrl = document.referrer;
			$el.addEventListener( 'click', () => {
				// Only reload page if the previous page is related to the dashboard
				previousUrl.includes('my-dashboard') ? window.location.href = previousUrl: history.back();
			} );
			const hideClass = 'invisible';
			$el.classList.remove( hideClass );
		}
	} );

	document.querySelectorAll( '.js-close-details' ).forEach( ( $el ) => {
		$el.addEventListener( 'click', () => {
			window.close();
		} );
	} );
} );
